// opervex-frontend/src/Opervex/System/Template.js

class Template {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/System/Template/", data);
  }

  async update(id, data) {
    return this.#_api.put("/System/Template/" + id, data);
  }

  async findId(id) {
    return await this.#_api.get("/System/Template/" + id);
  }

  async findAll() {
    return await this.#_api.get("/System/Template");
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "text",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: false,
      },
    ];
  }
}

export default Template;
